import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback } from 'react';
import InputField from '../InputField';
import s from './LimitedTextInputField.scss';
/** One of our standard `<input type="text" />`s.
 *
 * Limits input to a specified length (`max`) and displays the remaining character allowance to the right of the inner input.
 */ const LimitedTextInputField = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { maxLength, value, onChange } = _param, rest = _object_without_properties(_param, [
        "maxLength",
        "value",
        "onChange"
    ]);
    const handleOnChange = useCallback((e)=>{
        if (e.target.value.length > maxLength) {
            return;
        }
        onChange && onChange(e);
    }, [
        onChange,
        maxLength
    ]);
    return /*#__PURE__*/ React.createElement(InputField, _object_spread_props(_object_spread({
        type: "text",
        maxLength: maxLength,
        value: value,
        onChange: handleOnChange,
        postfix: /*#__PURE__*/ React.createElement("span", {
            className: s['postfix']
        }, maxLength - value.length)
    }, rest), {
        ref: ref
    }));
});
export default LimitedTextInputField;
